// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__2efTV","Div":"CustomFadeBox_Div__1VIG6","LargeDiv":"CustomFadeBox_LargeDiv__yLHbS"};